import React, { useState } from "react";
import { Button } from "../../ui/button";
import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import Loader from "../../Loader/Loader";
import { editHoursEndpoint } from "../../../provider/adm/EstudiantePersonalizado/Hours/UpdateHours";

const EditHours = ({ idStudent, packageData, onClose }) => {
  const [hours, setHours] = useState(packageData.hours || 0);
  const [loading, setLoading] = useState(false);

  const handleEditHours = async () => {
    setLoading(true);
    const editData = {
      idStudent,
      hours: parseFloat(hours),
    };

    try {
      await editHoursEndpoint(editData, packageData.id);
    } catch (error) {
      console.error("Error editing hours package:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <DialogHeader>
        <DialogTitle>Editar paquete de horas</DialogTitle>
        <DialogDescription>
          Modifique las horas del paquete seleccionado
        </DialogDescription>
      </DialogHeader>
      <div className="grid gap-4 py-4">
        <div className="grid grid-cols-4 items-center gap-4">
          <Label htmlFor="hours" className="text-right">
            Valor en horas
          </Label>
          <Input
            id="hours"
            type="number"
            step="0.5"
            value={hours}
            onChange={(e) => setHours(e.target.value)}
            className="col-span-3 flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          />
        </div>
        <div className="text-sm text-gray-600">
          <p><strong>Fecha:</strong> {new Date(packageData.date).toLocaleDateString()}</p>
          <p><strong>ID Admin:</strong> {packageData.adminID}</p>
        </div>
      </div>
      <DialogFooter>
        <Button type="button" variant="ghost" onClick={onClose}>
          Cancelar
        </Button>
        <Button type="button" onClick={handleEditHours}>
          Guardar cambios
        </Button>
      </DialogFooter>
    </>
  );
};

export default EditHours;